import type { RouteRecordRaw } from 'vue-router';

export default {
  meta: { feature: 'baremetal' },
  path: 'baremetal',
  name: 'baremetal',
  component: () => import('@/views/dashboard/baremetal/servers.vue'),
} satisfies RouteRecordRaw;
